import sortDescendingOrder from "../sortDescendingOrder";

export default function sortAscendingOrder(x: any, y: any): number {
  return -sortDescendingOrder(x, y);
}
